import ready from './ready';
import contact from './contact';
import menu from './menu';
import about from './about';
import initializePaypalButton from './paypal_button';


ready([initializePaypalButton, menu, contact, about]);



// WEBPACK FOOTER //
// ./src/js/app.js